export const WIDGET_FONT_FAMILY =
  'system-ui, -apple-system, "Segoe UI", Roboto, sans-serif';

export class ThemeFontLock {
  constructor(private readonly mount: HTMLElement) {}

  attach(): void {
    this.apply();
    const fonts = document.fonts;
    if (fonts) void fonts.ready.then(() => this.apply());
  }

  apply(): void {
    ThemeFontLock.write(this.mount, WIDGET_FONT_FAMILY);
  }

  static write(mount: HTMLElement, family: string): void {
    const next = family.trim();
    if (!next) return;
    if (mount.style.getPropertyValue("--nv-font-family") === next) return;
    mount.style.setProperty("--nv-font-family", next);
  }
}
